import script from "./RegistroCliente.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroCliente.vue?vue&type=script&setup=true&lang=js"

import "./RegistroCliente.vue?vue&type=style&index=0&id=38d6894e&scoped=true&lang=css"
import "./RegistroCliente.vue?vue&type=style&index=1&id=38d6894e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d6894e"]])

export default __exports__